import React from 'react';

interface ThumbsUpProps {
  /** Fill the glyph (selected state); outline when false. */
  filled?: boolean;
}

/**
 * Design-system thumbs-up — the exported "Interface, Essential/thumbs-up-like-3-big"
 * asset (Figma node 2409:15725). The 12.33×11.67 glyph sits inside a 16px box at
 * the design's insets (16.67% top/bottom, 16.67% left, 12.51% right), so the
 * viewBox is the asset's own and the box is set by width/height.
 * Thumbs-down is this icon rotated 180°, exactly as the design builds it.
 */
export const ThumbsUp: React.FC<ThumbsUpProps> = ({ filled = false }) => (
  <svg
    width="16"
    height="16"
    viewBox="-1.834 -1.667 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M7.30953 4.3093H10.1658C10.6791 4.3093 11.1637 4.54575 11.4795 4.95028C11.7954 5.35481 11.9072 5.88229 11.7827 6.38019L10.9108 9.86793C10.72 10.6311 10.0343 11.1664 9.24771 11.1664H1.35714C0.883755 11.1664 0.5 10.7827 0.5 10.3093V5.16644C0.5 4.69305 0.883755 4.3093 1.35714 4.3093H3.5V4.30753L4.61218 1.01787C4.67707 0.825951 4.81572 0.667781 4.99748 0.578317C5.17925 0.488853 5.38916 0.475463 5.58081 0.541106L6.02191 0.692173C6.79211 0.955947 7.30952 1.68006 7.30953 2.49417V4.30753"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 11.1649V4.3093"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
